/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import RenderSections from '@msr/Common/RenderSections';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
  fetchFooterDetailData,
  fetchHeaderMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 *
 * @param pageData.pageData
 * @param {object} pageData
 * @param pageData.lang
 * @returns
 */
const Lang = ({ pageData, lang }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang('', lang);
  }, [authContext, '', lang]);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={''}
        lang={lang}
      />

      <Box as="section" className="container" p="0" dir={lang == "fa" ? "rtl" : ""}>
        {pageData?.body?.length && pageData?.body[0]?.value.length
          ? pageData.body[0]?.value.map((section, i) => {
              return (
                <RenderSections
                  section={section}
                  region={''}
                  lang={lang}
                  key={nanoid(4)}
                />
              );
            })
          : null}
      </Box>
      <PageConfig isLikeVisible={false} pageData={pageData} />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
        `/mahashivratri/ta`,
        `/mahashivratri/hi`,
        `/mahashivratri/te`,
        `/mahashivratri/ne`,
        `/mahashivratri/ru`,
        `/mahashivratri/volunteer-terms-and-conditions`,
      ]
    : await getLandingPaths('lvl0', '/mahashivratri/', '', [
        '/mahashivratri/faq/',
        '/mahashivratri/adiyogi-pradakshina/',
        '/mahashivratri/attend-in-person/',
        '/mahashivratri/privacy-policy',
        '/mahashivratri/live-webstream/',
        '/mahashivratri/live-webstream-event/',
        '/mahashivratri/participate/',
        '/mahashivratri/shiva/',
        '/mahashivratri/thevaram/',
        '/mahashivratri/celebrations/',
        '/mahashivratri/participate/',
        '/mahashivratri/volunteer-coordinators/',
        '/mahashivratri/downloads/',
        '/mahashivratri/past-celebration/',
        '/mahashivratri/significance-of-mahashivratri/',
        `/mahashivratri/performing-artists`,
        '/mahashivratri/performing-artists-before',
        '/mahashivratri/performing-artists-after',
        '/mahashivratri/yaksha-live-two',
        '/mahashivratri/yaksha-live',
        '/mahashivratri/search',
        '/mahashivratri/volunteering',
        '/mahashivratri/tamil-thembu',
        // '/mahashivratri/tamil-thembu-2025',
        '/mahashivratri/fun-activities',
        '/mahashivratri/host-watch-party',
      ]);
  return {
    paths: msrPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { lang },
}) => {
  let language = lang;
  let path = '/';
  if (language?.length > 2) {
    language = 'en';
    path = lang;
  }
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language, 'msr'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('', language, 'msr'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', language, path, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      lang: lang,
      menuType: 'msrmainmenu',
    },
  };
};

export default Lang;
